import { getCustomFieldId, isCustomField } from "@app.raytd.com/common/utils/test-suites/getFieldRequirement";


interface ItemWithCustomFields {
    custom?: {
        [key: string]: any;
    };
    [key: string]: any;
}

/**
 * Extracts the value of a field from an item
 * @param fieldName 
 * @param item 
 * @returns 
 */
function extractFieldValue(fieldName: string, item: ItemWithCustomFields) {

    if (isCustomField(fieldName)) {
        return item['custom']?.[getCustomFieldId(fieldName)];
    }
    return item[fieldName];
}

export default extractFieldValue;